import * as $ from 'jquery'
import {
  ifElse,
  always,
  equals,
  when,
  complement,
  prop,
  isNil,
  gte
} from 'ramda'
import browser from 'browser-detect';
import moment from "moment"
import {CLOUD_URL} from "../constants";
import * as createGuest from "cross-domain-storage/guest";
import {refreshToken} from "../API/reader";
import {USER_STORAGE_ID} from "../constants";
import {getPdtPosition} from "./pdfUtilities";
import {getCfi} from "./epubUtilities";
import {getFb2Position} from "./fb2Utilities";

export const isIE = () => /Trident\/|MSIE/.test(window.navigator.userAgent)

export const isTokenExpired = ({expiresAt}) =>
  gte(moment().diff(moment(expiresAt), 'minutes'), 0)

export const goToCloud = () => {
  window.location = CLOUD_URL
}

export const getCloudUser = (search, onSetBaseParams) => {
  let cloudStorage = createGuest(CLOUD_URL + '?getStorage');
  let u = false

  cloudStorage.get(USER_STORAGE_ID, (e, user) => {
    u = user
  })

  let limit = 0
  let wait = setInterval(() => {
    if (u) {
      if (isTokenExpired(u)) {
        if (u.rememberPassword) {
          refreshToken().then(storedUser => {
            let path = u.path
            if (!path) {
              goToCloud()
            }
            u = storedUser
            onSetBaseParams(u, path)
          }).catch(() => {
            goToCloud()
          })
        } else {
          goToCloud()
        }
      } else {
        let path = search.length > 0 ? search.slice(1) : ''
        onSetBaseParams(u, path)
      }
      clearInterval(wait)
    } else if (limit > 10) {
      u = getUser()
      if (u === null) {
        goToCloud()
      }
    } else {
      limit++
    }
  }, 300)
}

export const getUser = () => {
  const user = window.localStorage.getItem(USER_STORAGE_ID)
  return user ? JSON.parse(user) : null
}

export const storeUser = (user) => {
  if (!user) return false

  window.localStorage.setItem(USER_STORAGE_ID, JSON.stringify(user))
  return true
}

export const getStoreAppearence = () => {
  const color = window.localStorage.getItem('appearenceTextColor')
  const size = window.localStorage.getItem('appearenceTextSize')
  const font = window.localStorage.getItem('appearenceTextFont')
  const flow = window.localStorage.getItem('appearenceTextFlow')

  return {
    color: color ? color : undefined,
    size: size ? size : undefined,
    font: font ? font : undefined,
    flow: flow ? flow : undefined
  }
}

export const storeColor = (value) => {
  window.localStorage.setItem('appearenceTextColor', value)
  return true
}

export const storeSize = (value) => {
  window.localStorage.setItem('appearenceTextSize', value)
  return true
}

export const storeFont = (value) => {
  window.localStorage.setItem('appearenceTextFont', value)
  return true
}

export const storeFlow = (value) => {
  window.localStorage.setItem('appearenceTextFlow', value)
  return true
}

export const updateUser = (user) => {
  if (!user) return false

  const oldUserInfo = getUser()
  !oldUserInfo ? storeUser(user) : storeUser({...oldUserInfo, ...user})
}

export const getAccessToken = () => when(
  complement(isNil),
  prop('access_token')
)(getUser())

export const env = ({dev = () => {}, prod = () => {}}) => ifElse(
  equals('development'),
  dev,
  prod
)(process.env.NODE_ENV)

export const formatBytes = (a, b = 2) => ifElse(
  equals(0),
  always('0 KB'),
  () => {
    const c = 1024
    const d = b
    const e = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
    const f = Math.floor(Math.log(a)/Math.log(c))
    return parseFloat((a/Math.pow(c,f)).toFixed(d))+" "+e[f]
  }
)(a)

const pad = (string) => {
  return ('0' + string).slice(-2)
}

export const dateForSaveNote = () => {
  const date = new Date()

  const month = date.getUTCMonth() + 1 < 10 ? '0' + (date.getUTCMonth() + 1) : date.getUTCMonth() + 1
  const year = date.getUTCFullYear()
  const day = date.getUTCDate() < 10 ? '0' + date.getUTCDate() : date.getUTCDate()

  const hh = date.getUTCHours()
  const mm = date.getUTCMinutes()
  const ss = pad(date.getUTCSeconds())

  return `${year}-${month}-${day}T${hh}:${mm}:${ss}+03:00`
}

export const formatDate = (dateInString, withTime) => {
  const date = new Date();
  date.setTime(dateInString * 1000)

  const month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
  const year = date.getFullYear()
  const day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()

  if( withTime ) {
    const hh = date.getHours()
    const mm = date.getMinutes()

    return `${day}/${month}/${year} ${hh}:${pad(mm)}`
  }

  return `${day}/${month}/${year}`
}

export const subCompare = (needle, haystack, min_substring_length) => {
  min_substring_length = min_substring_length || 1;

  for (let i=needle.length; i>=min_substring_length; i--) {
    for (let j=0; j <= (needle.length - i); j++) {
      let substring = needle.substr(j,i);
      let k = haystack.indexOf(substring);
      if (k !== -1) {
        return {
          found : 1,
          substring : substring,
          needleIndex : j,
          haystackIndex : k
        }
      }
    }
  }
  return {
    found : 0
  }
}

export const notChildren = (flags, target, childs) => {
  if (childs) {
    for(let i=0;i<childs.length;i++) {
      flags.push(target !== childs[i])
      if (childs[i]) notChildren(flags, target, childs[i].children)
    }
  } else {
    return true
  }
}

export const closePopups = (documentOnClick, nextDropdown) => {
  documentOnClick.addEventListener('click', (e) => {
    const target = e.target
    const nav = document.getElementsByClassName('Reader__navigation')[0]
    let flags = []
    if (!nav) return
    notChildren(flags, target, nav.children)
    if (!(flags.indexOf(false) > -1)) {
      nextDropdown('')
    }
  })
}

const getCoords = (elem) => {
  let box = elem.getBoundingClientRect();

  let body = document.body;
  let docEl = document.documentElement;

  let scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
  let scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;

  let clientTop = docEl.clientTop || body.clientTop || 0;
  let clientLeft = docEl.clientLeft || body.clientLeft || 0;

  let top  = box.top +  scrollTop - clientTop;
  let left = box.left + scrollLeft - clientLeft;

  return { top: Math.round(top), left: Math.round(left) };
}

export const onMouseUp = (e, changeHighlighModalPosition, toggleActiveHighlight, activeHighlight, onSelected, setOpenAddNote,
                          openNoteClass, outIframe , openMain = false, isDrag) => {
  e.stopPropagation()

  const viewer = document.getElementById('viewer'),
    headerH = outIframe ? 0 : document.getElementsByClassName('Header')[0].offsetHeight,
    windowH = window.innerHeight,
    windowW = window.innerWidth;
  let popupW = 240
  let popupH = 100

  if (openNoteClass && openNoteClass === 'openEditNote') {
    popupH = 178
    popupW = 315
  } else if (openNoteClass && openNoteClass === 'openEditHighlight') {
    popupH = 148
  }

  const offset = {
    top: outIframe ? 0 : viewer.offsetTop,
    left: outIframe ? 0 : viewer.offsetLeft
  }

  const limitLeft = windowW - popupW,
    limitTop = windowH - popupH;

  let x = e.pageX
  let y = e.pageY

  let mouseLeft =  offset.left + x + 5
  let mouseTop =  offset.top + headerH + y - popupH - 10

  if (!outIframe) {
    let searchbody = $(e.target).closest('body')[0]
    if (!searchbody) {
      searchbody = e.target.getElementsByTagName('body')[0]
    }
    let arrFrames = document.getElementsByTagName("iframe")

    for(let i = 0; i<arrFrames.length; i++) {
      try{
        if(arrFrames[i].id !== 'PeopleDetailsIframe'){

          if(arrFrames[i].contentWindow.document.body === searchbody){
            let section = $(arrFrames[i]).closest('.epub-view')[0]

            offset.left = getCoords(section).left
            offset.top = getCoords(section).top
          }
        }
      }
      catch(e){}
    }
    mouseLeft =  offset.left + e.clientX + 5
    mouseTop =  offset.top + e.pageY - popupH - 10

    let isEdge = browser().name === 'edge'
    if (isEdge && (document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement)) {
      mouseLeft = mouseLeft - 380
      mouseTop = mouseTop - 120
    }
  }

  if (mouseLeft > limitLeft) {
    mouseLeft = limitLeft
  } else if (mouseLeft < 0){
    mouseLeft = 0
  }

  if (mouseTop > limitTop) {
    mouseTop = limitTop
  } else if (mouseTop < 0){
    mouseTop = 0
  }

  changeHighlighModalPosition(mouseTop, mouseLeft)

  let popup = document.getElementsByClassName(openNoteClass).length
  if ($(e.target).hasClass('mark')) {
    let isOpen = $(e.target).hasClass('open')
    toggleActiveHighlight(!isOpen)

    let marks = document.getElementsByClassName('mark')
    for (let i=0; i< marks.length; i++) {
      let mark = marks[i]
      if (mark === e.target) {
        $(e.target).toggleClass('open')
      } else {
        $(mark).removeClass('open')
      }
    }
  }
  if (popup === 0 || openNoteClass === 'openEditHighlight') {
    setOpenAddNote(!activeHighlight ? openNoteClass : '')
    toggleActiveHighlight(!activeHighlight)
  }
}

export const getStateIndex = (prevStates, state, startIndex = 1) => {
  let index = 0
  for(let i=startIndex; i<prevStates.length; i++) {
    let prevState = prevStates[i]
    let statePage = state.page.toString()
    if (!prevState.page) continue
    let prevPage = prevState.page.toString()
    if (prevPage.indexOf('-') > -1) {
      let s = prevPage.split('-')
      prevPage = s[0]
    }

    if (prevPage === statePage && prevState.location === state.location) {
      index++
    }
  }
  return index
}

export const getWidthByFontSize = (fontSize) => {
  let w = (fontSize-5)*70
  let wMax = window.innerWidth - 160
  if (w > wMax) w = wMax
  else if (w < 680) w = 680
  return w
}

export const createExportFile = (filename, text) => {
  let element = document.createElement('a');
  element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
  element.setAttribute('download', filename);

  element.style.display = 'none';
  document.body.appendChild(element);

  element.click();

  document.body.removeChild(element);
}

export const getBookmarkPage = (rendition, bookmark) => {
  let page = false
  const anchor = bookmark.mark.anchor
  if (anchor.indexOf('pdfloc') > -1) {
    page = getPdtPosition(anchor)
  } else if (anchor.indexOf('cfi') > -1) {
    const cfi = getCfi(anchor)
    page = rendition.book && rendition.book.locations.total > 0 && cfi ? rendition.book.locations.locationFromCfi(cfi) + 1 : ''
  } else {
    page = getFb2Position(anchor)
  }
  return page
}


// WEBPACK FOOTER //
// ./src/utilities/utilities.js